import React, { Component } from 'react';
import authService from './api-authorization/AuthorizeService'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';
import Popup from './popup/reactjs-popup.cjs.development';
import 'reactjs-popup/dist/index.css';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import { YMaps, GeolocationControl, Geolocation, Map, Placemark } from '@pbe/react-yandex-maps';
import ReactRegionSelect from 'react-region-select';
import Input from 'react-phone-number-input/input';
import SideNav, { ClickOutside, NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import AsyncSelect from 'react-select/async';
import MultiRangeSlider from "./slider/multiRangeSlider";
import DOMPurify from 'dompurify'

export class Booking extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    console.log(this.props.match.params);
    //let { companyId, serviceId } = this.props.params;
    this.state = {
      companies: [],
      services: [],
      categories: [],
      orders: [],
      resources: [],
      calendar: [],
      filters: [],
      selectedFilters: [],
      loading: true,
      geoposition: [55.558741, 37.378847],
      zoom: 14,
      mapBounds: [],
      regions: [],
      fixedCompanyId: parseInt(this.props.match.params.companyId) || 0,
      companyId: parseInt(this.props.match.params.companyId) || 0,
      serviceId: parseInt(this.props.match.params.serviceId) || 0,
      categoryIds: [],
      categoryLists: [],
      companyInfo: {userRating: 0, feedback: [], resources: []},
      resourceInfo: {userRating: 0, feedback: []},
      duration: 1,
      selectedDate: curDate,
      selectedMonth: curDate,
      expanded: false,
      phone: '+7',
      userName: '',
      partialBooking: null,
      partialBookingText: '',
      cities: [],
      city: null,
      sort: 1
    };
    this.selectDate = this.selectDate.bind(this);
    this.selectMonth = this.selectMonth.bind(this);
    this.renderPopupContent = this.renderPopupContent.bind(this);
    this.selectorRef = React.createRef(null);
    this.geopositionSuccess = this.geopositionSuccess.bind(this);
    this.regionRenderer = this.regionRenderer.bind(this);
    this.handleSubmitCompanyFeedback = this.handleSubmitCompanyFeedback.bind(this);
    this.handleSubmitResourceFeedback = this.handleSubmitResourceFeedback.bind(this);
    this.debouncedLoadOptions = this.debounce(this.fetchOptions, 500);
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();

    this.populateCompaniesData();
    this.populateCategoriesData();
    this.populateServicesData();
    this.populateFiltersData();
    if (this.state.companyId > 0) {
      this.populateCalendarData();
      this.populateResourcesData();
      this.populateOrdersData();
    }
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name
    }));
  }

  selectCompany(companyId) {
    this.setState(prevState => ({...prevState, companyId: this.state.companyId !== companyId ? companyId : 0}));
    this.populateServicesData();
    this.populateFiltersData();
    this.populateCalendarData();
    this.populateResourcesData();
    this.populateOrdersData();
  }

  selectService(serviceId) {
    var newServiceId = this.state.serviceId !== serviceId ? serviceId : 0;
    this.setState(prevState => ({...prevState, serviceId: newServiceId, expanded: false}));
    this.populateCompaniesData();
    if (!newServiceId) {
      this.setState(prevState => ({...prevState, regions: [], resources: [], resourceId: null, calendar: [], orders: []}));
      return;
    }
    this.populateFiltersData();
    this.populateCalendarData();
    this.populateResourcesData();
    this.populateOrdersData();
  }

  selectResource(resourceId) {
    this.setState(prevState => ({...prevState, resourceId: this.state.resourceId !== resourceId ? resourceId : null}))
  }

  async addCategory(categoryId, level, defaultServiceId) {
    var oldArray = this.state.categoryIds;
    var oldLists = this.state.categoryLists;
    var removing = oldArray.length > level + 1 && oldArray[level + 1] === categoryId;
    oldArray.length = level + 1;
    oldLists.length = level + 1;
    if (removing) {
      this.setState(prevState => ({...prevState, categoryIds: oldArray, categoryLists: oldLists, serviceId: 0, expanded: false}));
    }
    else {
      this.setState(prevState => ({...prevState, categoryIds: [...oldArray, categoryId], categoryLists: oldLists, serviceId: defaultServiceId ?? 0, expanded: !defaultServiceId}));
      this.populateCategoriesList(categoryId);
    }
    await this.populateCompaniesData();
    await this.populateServicesData();
  }

  selectTime(pos, times) {
    /*if (pos === undefined || pos === null ) {
      return;
    }
    var times = this.state.orders.filter(cal => this.state.selectedDate.getTime() === new Date(cal.date).getTime() && pos >= Math.floor(cal.start / 100) && (pos + 1) < (cal.end + 99) / 100);*/
    /*var regions = this.state.regions;
    var resourceId = this.state.resourceId;
    for (var r = 0; r < regions.length; r++) {
      for (var i = 0; i < regions[r].length; i++) {
        var orders = times.filter(cal => regions[r][i].data.resourceId === cal.resourceId);
        regions[r][i].data.disabled = orders.length>0?true:undefined;
        regions[r][i].data.regionStyle = {
          background: orders.length>0?"rgba(255, 0, 0, 0.5)":(resourceId===regions[r][i].data.resourceId?"rgba(0, 0, 255, 0.5)":"rgba(0, 255, 0, 0.5)")
        };
        if (resourceId===regions[r][i].data.resourceId && orders.length>0) {
          resourceId = undefined;
        }
      }
    }*/
    this.setState(prevState => ({...prevState, selectedTime: this.state.selectedTime !== pos ? pos : null, /*regions: regions, resourceId: resourceId,*/ filteredTimes: this.state.selectedTime !== pos ? times : null}));
  }

  addFilter(id) {
    if (this.state.selectedFilters.includes(id))
        this.setState(prevState => ({...prevState, selectedFilters: this.state.selectedFilters.filter(f => f !== id)}));
    else
        this.setState(prevState => ({...prevState, selectedFilters: [...this.state.selectedFilters, id]}));
    this.populateResourcesData();
  }

  increaseDuration(shift, res) {
    var newDur = this.state.duration + shift;
    if (newDur > res.maxTime / 3600)
      newDur = res.maxTime / 3600;
    if (newDur < res.minTime / 3600)
      newDur = res.minTime / 3600;
    if (newDur !== this.state.duration)
      this.setState(prevState => ({...prevState, duration: newDur}));
    return newDur;
  }

  displayDuration(dur, res) {
    var newDur = dur;
    if (res.bookingInterval === 4)
      newDur = newDur / 24;
    return newDur;
  }

  async createOrder(resourceId, time) {
    const token = await authService.getAccessToken();
    console.log(token);
    const user = await authService.getUser();
    if (!user)
      return;
    console.log(user);
    console.log(user.expired);
    if (user.expired) {
      const signin = await authService.signIn();
      console.log(signin);
    }

    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    var date = new Date(this.state.selectedDate.getTime() - this.state.selectedDate.getTimezoneOffset() * 60000);
    const response = await fetch(`{{mainApiUrl}}api/orders`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ serviceId: this.state.serviceId, resourceId: resourceId, start: time, end: time + Math.floor(this.state.duration)*100 + this.state.duration*100%100*60, date: date, userPhone: this.state.phone, userName: this.state.userName, partialBooking: this.state.partialBooking, partialBookingText: this.state.partialBookingText })
    });
    const data = await response.json();
    data.date = this.state.selectedDate;
    this.setState(prevState => ({...prevState, orders: [...prevState.orders, data], phone: '+7', userName: '', partialBooking: null, partialBookingText: ''}));
    this.populateCalendarData();
    if (this.state.selectedTime)
      this.setState(prevState => ({...prevState, filteredTimes: [...this.state.filteredTimes, data]}));
  }

  async cancelOrder(id) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/orders/${id}`, {
      method: "DELETE",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    await response.json();
    this.setState(prevState => ({...prevState, orders: prevState.orders.filter(order => order.id !== id)}));
    this.populateCalendarData();
  }

  getContent(date) {
    var slots = this.state.calendar.filter(cal => new Date(cal.day).getTime() === date.getTime());
    return (
      slots.length > 0 ? <div class="calbardiv"><span class="calredspan" style={{height: (slots[0].sumUsed * 100 / slots[0].sumHours).toString() + '%'}}></span><span class="calbarspan" style={{height: '100%'}}></span></div> : <div class="calbardiv"></div>
    );
  }

  renderIncreaseButton(shift, res) {
    return (
      <input style={{marginBottom: "5px"}} className="btn btn-primary" type="button" value={(shift > 0 ? '+' : '') + this.displayDuration(shift, res).toString()} id="Button_Plus05" onClick={() => this.increaseDuration(shift, res)}/>
    );
  }

  updatePartialBookingText(evt) {
    const val = evt.target.value;
    this.setState(prevState => ({...prevState, partialBookingText: val}));
  }

  renderPopupContent(pos, res, times, min) {
    /*if (!this.state.serviceId) {
      return <></>;
    }*/
    var closeTooltip = () => this.selectorRef.current.close();
    var orders = times;
    var selectedDate = this.state.selectedDate.toLocaleString(undefined, {weekday: "long", year: 'numeric', month: '2-digit', day: '2-digit'});
    if (orders && orders.length > 0 && !this.state.newbooking)
      return (
        <div>
          <p><span>{orders.filter(o => o.userId).length>0?<>Your</>:<>There {orders.length > 1 ? 'are' : 'is'}</>} booking{orders.length > 1 ? 's' : ''} on {selectedDate}</span></p>
          {orders.filter(o => o.userId).map(order =>
            <><p><span>Phone:</span>{order.userPhone}</p><p><span>Name:</span>{order.userName}</p><p>
              {res.bookingInterval === 4 ? (<>For</>) : (<><span>At {Math.floor(order.start / 100)}:{(order.start % 100).toString().padStart(2, '0')}</span> for</>)} {order.service}
            </p>
            <input className="btn btn-primary" type="button" value="Cancel booking" id="Button_Cancel" onClick={() => {this.cancelOrder(order.id); closeTooltip();}}/></>
          )}
          {orders.length < res.count ? <p><input className="btn btn-primary" type="button" value="New booking" id="Button_New" onClick={() => this.setState(prevState => ({...prevState, newbooking: true}))}/></p>:<></>}
        </div>
      );
    else {
      var incButtons = res.timeEditable ?
          <span>{this.renderIncreaseButton(res.timeStep > 0 ? res.timeStep / 3600 : 0.5, res)}
          {this.renderIncreaseButton(res.timeStep > 0 ? res.timeStep / 3600 * 2 : 1, res)}</span>
        : <span></span>;
      var decButtons = res.timeEditable ?
          <span>{this.renderIncreaseButton(res.timeStep > 0 ? -res.timeStep / 3600 * 2 : -1, res)}
          {this.renderIncreaseButton(res.timeStep > 0 ? -res.timeStep / 3600 : -0.5, res)}</span>
        : <span></span>;

      return (
        <div><p><span>You are creating booking on {selectedDate}</span></p>
          {res.admin ? (
          <><div class="bookphone"><label for="telNo">Телефон</label> <Input class="phoneinput" country="RU"
            value={this.state.phone !== undefined ? this.state.phone : ''}
            onChange={val => {this.setState(prevState => ({...prevState, phone: val})); this.populateUserData();}} disabled/><span className="backsp" onClick={() => {this.setState(prevState => ({...prevState, phone: this.state.phone.length>2?this.state.phone.substring(0,this.state.phone.length-1):"+7"})); this.populateUserData();}}/></div>
            <div style={{textAlign: "center"}}>{Array.from(Array(10).keys()).map(i => (<input className="btn btn-primary btn-phone" type="button" value={i==9?0:(i+1)} id={"Button_"+(i+1)} onClick={() => {this.setState(prevState => ({...prevState, phone: this.state.phone + (i==9?0:(i+1)).toString()})); this.populateUserData();}}/>))}</div>
          <div class="bookphone"><label for="uName">Имя</label> <input class="form-control" id="uName" type="text"
            value={this.state.userName !== undefined ? this.state.userName : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, userName: val}));}}/></div></>) : (<></>)}
          <p>{res.bookingInterval === 4 ? <></> : <><span>В {pos}:{(min??0).toString().padStart(2, '0')}</span> </>} {this.state.services.filter(s => s.id === this.state.serviceId)[0]?.name}</p>
          {res.partialBooking?(<><p><span className="radio-primary">
            <input name="PartialBooking" type="radio" value="RadioComplete" id="RadioComplete" checked={this.state.partialBooking === null} onClick={() => this.setState(prevState => ({...prevState, partialBooking: null}))}/><label className="btn btn-primary" for="RadioComplete">Полностью</label></span><span>Частично </span><span className="radio-primary">
      {Array.from(Array(res.partialBooking+1).keys()).map(i => i>1 && res.partialBooking%i==0 ? <><input name="PartialBooking" type="radio" value={'Radio' + i.toString()} id={'Radio'+i.toString()} checked={this.state.partialBooking===i} onClick={() => this.setState(prevState => ({...prevState, partialBooking: i}))}/><label className="btn btn-primary radio-gradient" for={'Radio'+i.toString()}>{'1 / ' + i.toString()}</label></>:<></>)}


          </span></p>{this.state.partialBooking?<div class="form-group">
          <label for="Input_PartialBookingText">Комментарий для участников</label>
          <textarea style={{marginBottom: "5px"}} class="form-control" type="text" id="Input_PartialBookingText" name="Input.PartialBookingText" value={this.state.partialBookingText} onChange={evt => this.updatePartialBookingText(evt)}/>
        </div>
:<></>}</>):<></>}
          {res.minTime ? <p>На {decButtons} <span>{this.displayDuration(this.increaseDuration(0, res), res)}</span> {res.bookingInterval === 4 ? 'day':'hour'}{this.displayDuration(this.state.duration, res) > 1 ? 's' : ''} {incButtons}</p> : <></>}
          {res.price > 0 ? <p>Цена: {res.price * this.displayDuration(this.state.duration, res) / this.state.partialBooking?this.state.partialBooking:1}</p> : <></>}
        {this.state.isAuthenticated?
          <input className="btn btn-primary" type="button" value="Забронировать" id="Button_Book" disabled={!res.minTime} onClick={() => {this.createOrder(res.id, pos*100 + (min??0)); closeTooltip();}}/>:
          <a class="btn btn-primary" href="authentication/login">Войти</a>}
          </div>
      );
    }
  }

  RenderPopup(pos, res, times, min) {
    var filtered = times.filter(cal => res.id === cal.resourceId && (pos*100+min) >= cal.start && (pos*100+min) < cal.end);
    var userorders = filtered.filter(o => o.userId);
    if (filtered.length == 0)
    {
      var minTime = res.minTime/3600*100+(res.readinessTime??0)/60*100;
      minTime = Math.floor(minTime/100)*100+((minTime%100)/100*60);
      var filteredMinTime = times.filter(cal => res.id === cal.resourceId && cal.start > (pos*100+min) && cal.start < (pos*100+min+minTime));
      var notWorkingHours = res.bookingInterval <= 3 && this.isBlockedTime(pos+min/60, res);
      var endNotWorkingHours = res.bookingInterval <= 3 && res.minTime > 0 && this.isBlockedTime(pos+min/60+(res.minTime-1)/3600, res);
      if (!res || notWorkingHours || filteredMinTime.length > 0 || endNotWorkingHours) {
        return (
          <td class="calcell" title={notWorkingHours?"Нерабочее время":`${res.minTime!=res.maxTime?"Минимальное в":"В"}ремя услуги: ${res.minTime/3600} час${res.minTime/3600==1?"":"а"}`}>
            <div class="blockedcell" style={{width: '100%'}}></div>
          </td>
        );
      }
    }
    return (
      <Popup ref={this.selectorRef}
        className="popup-book"
        trigger={open => (
          <td class="calcell" title={filtered.map(t => t.service)}>
            <div class={filtered.length>0 && filtered[0].partialBooking?"partlcell":(userorders.length>0?"bookedcell":"bookedcellimg")} style={{width: (filtered.length*100/res.count).toString() + '%'}}>{filtered.length>0 && filtered[0].partialBooking?"1 / "+filtered[0].partialBooking.toString():(userorders.length>0?userorders[0].service:"")}</div>
            {filtered.length==0 || !filtered[0].partialBooking?<div class="availcell" style={{width: filtered.length === res.count?'0%':'100%'}}></div>:<></>}
          </td>
        )}
        onClose={() => this.setState(prevState => ({...prevState, duration: 1, newbooking: undefined}))}
        position="bottom center"
        closeOnDocumentClick>{() => this.renderPopupContent(pos, res, filtered, min)}</Popup>
    );
  }

  RenderRow(pos, res) {
    var times = this.state.orders.filter(cal => this.state.selectedDate.getTime() === new Date(cal.date).getTime() && pos >= Math.floor(cal.start / 100) && (pos + 1) < (cal.end + 99) / 100);
    if (this.state.resources.filter(res => res.bookingInterval <= 3).length == 0) {
      if (pos != 0) return (<></>);
      return (
        <tr key={pos}>
          {this.state.resources.filter(res => !this.state.resourceId || this.state.resourceId === res.id).map(res => this.RenderPopup(pos, res, times, 0))}
        </tr>
      );
    }
    var count = this.state.resources.filter(res => res.bookingAlignment === 4).length>0?2:1;
    count = this.state.resources.filter(res => res.bookingAlignment === 5).length>0?4:count;
    count = this.state.resources.filter(res => res.bookingAlignment === 6).length>0?12:count;
    return (
      Array.from(Array(count).keys()).map(c => <tr key={pos}>
        <th onClick={() => this.selectTime(pos, times)} className={this.state.selectedTime === pos?'tablefix2 react-calendar__tile--active':'tablefix2'}>{c==0?pos+':':''}{(60/count*c).toString().padStart(2, '0')}</th>
        {this.state.resources.filter(res => !this.state.resourceId || this.state.resourceId === res.id).map(res => this.RenderPopup(pos, res, this.state.orders, c==0?0:(60/count*c)))}
      </tr>)
    );
  }

  selectDate(date, event) {
    this.setState(prevState => ({...prevState, selectedDate: date}));
    this.populateResourcesData();
    this.populateOrdersData();
  }

  selectMonth({action, activeStartDate, value, view}) {
    this.setState(prevState => ({...prevState, selectedMonth: activeStartDate}));
    this.populateCalendarData();
  }

  getGeoLocation(ymaps) {
    return ymaps.geolocation
      .get({ provider: "yandex", mapStateAutoApply: true })
      .then(result =>
        ymaps.geocode(result.geoObjects.position).then(res => {
          let firstGeoObject = res.geoObjects.get(0);
          console.log(firstGeoObject.getLocalities());
          console.log(
            firstGeoObject.getLocalities().length
              ? firstGeoObject.getLocalities()
              : firstGeoObject.getAdministrativeAreas()
          );
        })
      );
  };

  mapOnLoad(ymaps) {
    //const geolocation = this.getGeoLocation(ymaps);
    //const { ymaps } = useYMaps();
    navigator.geolocation.getCurrentPosition(this.geopositionSuccess, this.error);
    /*if (navigator.geolocation) {
      navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
        if (result.state === 'granted') {
          console.log(result.state);
          handleLocation();
        } else if (result.state === 'prompt') {
          console.log('prompt');
        } else if (result.state === 'denied') {
          console.log('Denied');
        }
      });
    }*/
  };

  onGeoposition() {
    if (this.state.mapZoom != 14) {
      this.setState(prevState => ({...prevState, zoom: 13}));
    }
    navigator.geolocation.getCurrentPosition(this.geopositionSuccess, this.error);
  }

  geopositionSuccess(position) {
    console.log(position);
    this.setState(prevState => ({...prevState, zoom: 14, geoposition: [position.coords.latitude, position.coords.longitude], bounds: null}));
    this.populateCurrentCity();
  }

  error() {
    console.log('geopositionError');
  }

  selectBounds(event) {
    var bounds = event.get('newBounds');
    var zoom = event.get('newZoom');
    console.log(bounds);
    console.log(zoom);
    this.setState(prevState => ({...prevState, mapBounds: bounds, mapZoom: zoom}));
  }

  onRegionChange(val) {
  }

  selectResourceRegion(region) {
    console.log(this.state.regions);
    /*var regions = this.state.regions;
    for (var i = 0; i < regions[region.data.mapIndex].length; i++) {
      if (regions[region.data.mapIndex][i].data.resourceId === this.state.resourceId) {
        regions[region.data.mapIndex][i].data.regionStyle = {
          background: "rgba(0, 255, 0, 0.5)"
        };
      }
    }
    region.data.regionStyle = {
      background: "rgba(0, 0, 255, 0.5)"
    };*/
    this.setState(prevState => ({...prevState, resourceId: region.data.resource.id/*, regions: regions*/}));
  }

  regionRenderer(regionProps) {
    if (!regionProps.isChanging/* && regionProps.data.disabled !== true*/) {
      var res = regionProps.data.resource;
      var pos = this.state.selectedTime;
      var disabled = pos && this.isBlockedTime(pos, res);
      var orders = this.state.filteredTimes ? this.state.filteredTimes.filter(cal => res.id === cal.resourceId) : [];
      if (res.id !== this.state.resourceId || (!pos && res.bookingInterval <= 3) || orders.length > 0 || disabled) {
        var background = "rgba(127, 255, 127, 0.5)";
        if (disabled)
          background = "rgba(0, 0, 0, 0.5)";
        else if (orders.length > 0)
          background = "rgba(255, 127, 127, 0.5)";
        else if (res.id === this.state.resourceId)
          background = "rgba(0, 0, 255, 0.5)";
        return ( <div onClick={() => this.selectResourceRegion(regionProps)} style={{ position: "absolute", cursor: orders.length > 0 || disabled ? "default" : "pointer", width: "100%", height: "100%", background: background }}></div> );
      }
      else {
        return (
          <Popup ref={this.selectorRef}
            className="popup-book"
            trigger={open => (
              <div style={{ position: "absolute", cursor: "pointer", width: "100%", height: "100%", background: "rgba(0, 0, 255, 0.5)"}}></div>
            )}
            position="bottom center"
            closeOnDocumentClick>{() => this.renderPopupContent(pos??0, res)}</Popup>
        );
      }
    }
  }

  async addScheme(event) {
    /*var formData = new FormData();
    formData.append("file", event.target.files[0]);

    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/scheme`, {
      method: 'POST',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      },
      body: formData
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, company: {...prevState.company, schemes: [...prevState.company.schemes, data]}, selectedScheme: prevState.company.schemes.length}));*/
  }


  updateMyCompanyFeedback(text) {
    this.setState(prevState => ({...prevState, companyInfo: {...prevState.companyInfo, userText: text.target.value}}));
  }

  async handleSubmitCompanyFeedback() {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyInfo.id}/feedback`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ rating: this.state.companyInfo.userRating, text: this.state.companyInfo.userText })
    });


    const data = await response.json();
    var companyInfo = this.state.companyInfo;
    companyInfo.feedback = [...companyInfo.feedback, data];
    companyInfo.userText = "";
    companyInfo.userRating = 0;
    this.setState(prevState => ({...prevState, companyInfo: companyInfo}));
  }

  selectCompanyInfoImage(imageId) {
    this.setState(prevState => ({...prevState, companyInfo: {...prevState.companyInfo, selectedImage: imageId}}));
  }

  async onCompanyInfoOpen(companyId) {
    const token = await authService.getAccessToken();
    var url = `{{mainApiUrl}}api/companies/${companyId}/feedback`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companyInfo: {id: companyId, selectedImage: 0, userRating: 0, rating: data.averageRating, feedback: data.feedbackList, resources: data.resources}}));
  }

  selectCompanyUserRating(rating) {
    this.setState(prevState => ({...prevState, companyInfo: {...prevState.companyInfo, userRating: rating}}));
  }

  renderCompanyInfo(company) {
    return (
      <><div className="imagesqbig">
        <div class="imagesqbigleft">
          <img src={company.images[this.state.companyInfo.selectedImage]} alt="" class="schemecomp"/>
          <table className="table"><thead><tr><th>
            {company.images.map((x, i) => <div className={this.state.companyInfo.selectedImage === i?'companyimagesq react-calendar__tile--active':'companyimagesq'} onClick={() => this.selectCompanyInfoImage(i)}><img class="noimage" src={x} alt="" width="110px" height="110px"/></div>)}
          </th></tr></thead></table>
        </div>
        
        <div style={{display: "flow-root"}}>
          <h4>{company.name}</h4><div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(company.description)}}></div>
          <div class="avrate">
            <h5 class="avrate2">Рейтинг по оценкам:</h5><span className="star5"/><span className="star5 starbw" style={{clip: "rect(0px 150px 30px "+((company.rating??0)*30).toString()+"px)"}}/>
          </div>
          <div><h4>Лучшие предложения:</h4><div className="companyinfogroup">{this.state.companyInfo.resources.map(res =>
            <div className='companyresourcesq'><img src={res.images[0]} alt="" width="110px" height="110px"/>
              {/*res.rating===null*/false?<></>:<div class="compresrate"><span class="starsm5"></span><span class="starsm5 starbw" style={{clip: "rect(0px 100px 20px "+(res.rating*20).toString()+"px)"}}></span></div>}
            </div>)}
          </div></div>
        </div>
      </div>
      <div><h4>Отзывы</h4><div className="companyinfogroup">
        <div>
          {this.state.companyInfo.feedback.map(f => <div className="feedback"><div><b>{f.userName}</b></div>{Array.from(Array(f.rating).keys()).map(i => <span className="starsm"/>)}{f.date}<div>{f.text}</div></div>)}
        </div>
      </div></div>
      <div><h4>Оставить отзыв</h4><div className="companyinfogroup2">
        <div class="form-group">
          <label for="Input_CompanyDesc">Оценка:</label>{Array.from(Array(5).keys()).map(i => <span className={i >= this.state.companyInfo.userRating?"starbw star":"star"} onClick={() => this.selectCompanyUserRating(i + 1)}/>)}
        </div>
        <div class="form-group companyinfotextarea">
          <textarea class="form-control" type="text" id="Input_CompanyDesc" name="Input.CompanyDesc" value={this.state.companyInfo.userText} onChange={evt => this.updateMyCompanyFeedback(evt)}/>
        </div>
        <div class="form-group">
          <label for="scheme-upload" class="btn btn-primary">
            <i class="fa fa-cloud-upload"></i> Upload photo
          </label>
          <input id="scheme-upload" onChange={this.addScheme.bind(this)} type="file"/>
          <input class="btn btn-primary" type="button" value="Submit" id="Button_Save" onClick={this.handleSubmitCompanyFeedback}/>
        </div></div>
      </div></>
    );
  }

  updateMyResourceFeedback(text) {
    this.setState(prevState => ({...prevState, resourceInfo: {...prevState.resourceInfo, userText: text.target.value}}));
  }

  async handleSubmitResourceFeedback() {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/resources/${this.state.resourceInfo.id}/feedback`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ rating: this.state.resourceInfo.userRating, text: this.state.resourceInfo.userText })
    });


    const data = await response.json();
    var resourceInfo = this.state.resourceInfo;
    resourceInfo.feedback = [...resourceInfo.feedback, data];
    resourceInfo.userText = "";
    resourceInfo.userRating = 0;
    this.setState(prevState => ({...prevState, resourceInfo: resourceInfo}));
  }

  async onResourceInfoOpen(resourceId) {
    const token = await authService.getAccessToken();
    var url = `{{mainApiUrl}}api/resources/${resourceId}/feedback`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, resourceInfo: {id: resourceId, selectedImage: 0, userRating: 0, rating: data.averageRating, feedback: data.feedbackList}}));
  }

  selectResourceUserRating(rating) {
    this.setState(prevState => ({...prevState, resourceInfo: {...prevState.resourceInfo, userRating: rating}}));
  }

  renderResourceInfo(resource) {
    return (
      <><div className="imagesqbig">
        <div class="imagesqbigleft">
          <img src={resource.images[this.state.resourceInfo.selectedImage]} alt="" class="schemecomp"/>
          {resource.images.length>0?<table className="table"><thead><tr><th>
            {resource.images.map((x, i) => <div className={this.state.resourceInfo.selectedImage === i?'companyimagesq react-calendar__tile--active':'companyimagesq'} onClick={() => this.selectResourceInfoImage(i)}><img src={x} alt="" width="110px" height="110px"/></div>)}
          </th></tr></thead></table>:<></>}
        </div>
        <div style={{display: "flow-root"}}>
          <h4>{resource.name}</h4>
          <div class="avrate">
            <h5 class="avrate2">Рейтинг по оценкам:</h5><span className="star5"/><span className="star5 starbw" style={{clip: "rect(0px 150px 30px "+((this.state.resourceInfo.rating??0)*30).toString()+"px)"}}/>
          </div>
        </div>
      </div>
      <div><h4>Отзывы</h4><div className="companyinfogroup">
      <div>
        {this.state.resourceInfo.feedback.map(f => <div className="feedback"><div><b>{f.userName}</b></div>{Array.from(Array(f.rating).keys()).map(i => <span className="starsm"/>)}{f.date}<div>{f.text}</div></div>)}
      </div>
      </div></div>
      <div><h4>Оставить отзыв</h4><div className="companyinfogroup2">
        <div class="form-group">
          <label for="Input_CompanyDesc">Rating:</label>{Array.from(Array(5).keys()).map(i => <span className={i >= this.state.resourceInfo.userRating?"starbw star":"star"} onClick={() => this.selectResourceUserRating(i + 1)}/>)}
        </div>
        <div class="form-group">
          <textarea class="form-control companyinfotextarea" type="text" id="Input_CompanyDesc" name="Input.CompanyDesc" value={this.state.resourceInfo.userText} onChange={evt => this.updateMyResourceFeedback(evt)}/>
        </div>
        <div class="form-group">
          <label for="scheme-upload" class="btn btn-primary">
            <i class="fa fa-cloud-upload"></i> Upload photo
          </label>
          <input id="scheme-upload" onChange={this.addScheme.bind(this)} type="file"/>
          <input class="btn btn-primary" type="button" value="Submit" id="Button_Save" onClick={this.handleSubmitResourceFeedback}/>
        </div>
      </div></div></>
    );
  }

  renderCompaniesTable() {
    return (
      <div style={{paddingBottom: "1rem", minHeight: "360px"}}>
        <div className="rightcompdiv">
          <YMaps>
            <Map width={"100%"} height={"100%"} onLoad={ymaps => this.mapOnLoad(ymaps)} onBoundschange={event => this.selectBounds(event)} state={{center: this.state.geoposition, zoom: this.state.zoom, bounds: this.state.bounds}}>
              <GeolocationControl options={{ float: "left" }} onClick={() => this.onGeoposition()}/>
              {this.state.companies.filter(company => company.locationX !== null && company.locationY !== null && (company.id === this.state.fixedCompanyId || this.state.fixedCompanyId === 0)).map(company =>
                <Placemark geometry={[company.locationX, company.locationY]}
                           properties={{hintContent: company.name, balloonContent: `<div class="placemarkdiv"><img class="placemark" src="${company.images[0]}" width="100" height="100"/>${company.description ?? ''}</div>`, balloonContentHeader: company.name}}
                           options={{iconLayout: 'default#image', iconImageHref: company.images[0], iconImageSize: [30, 30], iconImageOffset: [-15, -15], iconShape: {type: 'Circle', coordinates: [0, 0], radius: 15}}}
                           modules={['geoObject.addon.balloon', 'geoObject.addon.hint']}/>
              )}
            </Map>
          </YMaps>
        </div>
        <div className="leftcompdiv">
          {this.state.companies.filter(company => company.id === this.state.fixedCompanyId || this.state.fixedCompanyId === 0).map(company =>
            <div key={company.id} onClick={() => this.selectCompany(company.id)} className={this.state.companyId === company.id ? 'companysq react-calendar__tile--active' : 'companysq'}>
              <div class="compsmallimagesq">
              {company.rating===null?<></>:<div class="comprate"><span class="starsm5"></span><span class="starsm5 starbw" style={{clip: "rect(0px 100px 20px "+(company.rating*20).toString()+"px)"}}></span></div>}
              <Popup ref={this.selectorRef}
                className="popup-info"
                trigger={open => (
                  <span className="iimage"></span>
                )}
                onOpen={() => this.onCompanyInfoOpen(company.id)}
                position="bottom center"
                repositionOnResize
                closeOnDocumentClick>
                {() => this.renderCompanyInfo(company)}
              </Popup>
              <img class="noimage" src={company.images[0]} alt="" width="110px" height="110px"/>
              </div>
              <div class="companysqprice">от 500 руб.</div>
              <div class="comanysqname">{company.name}</div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderCategories() {
    return (
      <div className="tabledivbig">
          {this.state.categories.map(category =>
            <div key={category.id} onClick={() => this.addCategory(category.id, -1, category.defaultServiceId)} className={'categorysq ' + (this.state.categoryIds.length > 0 && this.state.categoryIds[0] === category.id?'react-calendar__tile--active':'')}>
              <span class="categoryimg" style={{backgroundImage: "url(/category/"+category.id.toString()+".svg)"}}/><span class="categoryname">{category.name}</span>
            </div>
          )}
      </div>
    );
  }

  renderServicesTable() {
    const services = this.state.services.filter(service => service.id === this.state.serviceId);
    if (this.state.categoryIds.length === 0 && !this.state.companyId && !this.state.serviceSearch) {
      return <div class="serviceinfo"><span className="arrownone"/><span class="serviceinfotext">Для выбора услуги выберите категорию или компанию</span></div>;
    }
    return (
        <>
      <SideNav
        componentClass="servicepanel"
        className="leftpanel"
        expanded={this.state.expanded}
        onToggle={(expanded) => {
          this.setState({ expanded });
        }}
        >
        <SideNav.Toggle className="lefttoggle"/>
        <SideNav.Nav className="rightcontainer" selected={this.props.selected} expanded={this.state.servicesexpanded}>
            <table class="table table-striped flex-grow" aria-labelledby="tabelLabel"><tbody>
              {
                this.state.categoryLists.map((list, i) =>
          <>
              {list.map(category =>
                <><tr key={category.id} onClick={() => this.addCategory(category.id, i)} className={this.state.categoryIds.length > i + 1 && this.state.categoryIds[i + 1] === category.id?'react-calendar__tile--active':''}>
                  <td>{category.name}</td>
                </tr><tr>
                  <td><table className='table' aria-labelledby="tabelLabel">
            <tbody>
              {this.state.services.filter(service => service.categoryId === category.id).map(service =>
                <tr><td style={{padding: "0 0 0 0", textAlign: "left"}} key={service.id} onClick={() => this.selectService(service.id)} class={this.state.serviceId === service.id?'react-calendar__tile--active':''}>
                  <span className="arrowint"/><span>{service.name}</span></td></tr>
              )}
              
              </tbody></table></td>
                </tr></>
              )}
            </>
        )
              }
            </tbody></table>
        <table className='table table-striped' aria-labelledby="tabelLabel">
          <tbody>
            {this.state.services.filter(service => this.state.categoryIds.length <= 0 || service.categoryId === this.state.categoryIds[0]).map(service =>
              <tr key={service.id} onClick={() => this.selectService(service.id)}>
                <td className={this.state.serviceId === service.id?'react-calendar__tile--active':''} style={{textAlign: "left"}}>{service.name}</td>
              </tr>
            )}
          </tbody>
        </table>
        </SideNav.Nav>
      </SideNav>
      {services.length == 0 ? <div class="selectservice" onClick={() => this.setState(prevState => ({...prevState, expanded: true}))}><span>Выберите услугу</span></div>:
        <div className="tablediv">
        {this.state.categoryLists.map((list, i) =>
          <><table className='table table-striped servicetab' aria-labelledby="tabelLabel">
            <tbody>
              {list.filter(c => c.id == services[0].categoryId).map(category =>
                <tr key={category.id} onClick={() => this.addCategory(category.id, i)}>
                  <td className={this.state.categoryIds.length > i + 1 && this.state.categoryIds[i + 1] === category.id?'react-calendar__tile--active':''} style={i==0?{paddingLeft: "2.5rem", border: "0"}:{border: "0"}}>{category.name}</td>
                </tr>
              )}
            </tbody>
          </table><div style={{float: "left"}}><span className="arrowright" style={{backgroundImage:this.state.expanded?"none":""}}/></div></>
        )}
        <table className='table table-striped servicetabmain' aria-labelledby="tabelLabel">
          <tbody>
            {this.state.services.filter(service => service.id === this.state.serviceId).map(service =>
              <tr key={service.id} onClick={() => this.selectService(service.id)}>
                <td className={this.state.serviceId === service.id?'react-calendar__tile--active':''} style={this.state.categoryLists.length==0 || this.state.categoryLists[0].filter(c => c.id == services[0].categoryId)==0 ? {paddingLeft: "2.5rem", border: "0"}:{border: "0"}}>{service.name}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>}
      </>
    );
  }

  findMin(arr) {
    return Math.min(...arr.map(node => node.startTime>node.endTime?0:node.startTime));
  }

  findMax(arr) {
    return Math.max(...arr.map(node => node.startTime>node.endTime?2400:node.endTime));
  }

  isBlockedTime(pos, res) {
    return (res.endTime>res.startTime && (pos<res.startTime/100 || pos>=res.endTime/100)) || (res.endTime<res.startTime && pos>=res.endTime/100 && pos<res.startTime/100);
  }

  renderCalendar() {
    const regionStyle = {
      //cursor: "default",
      border: "none",
      //background: "rgba(0, 255, 0, 0.5)",
      zIndex: 99
    };
    return (
      <div>
      <Calendar
        tileContent={({ date, view }) => view === 'month' ? this.getContent(date) : null}
        onChange={this.selectDate} onActiveStartDateChange={this.selectMonth} value={this.state.selectedDate}/>

      <div style={{paddingBottom: "0.3rem"}}><div class="searchimg"><i class="fa-solid fa-magnifying-glass fa-xl"></i></div><input class="form-control searchinput" type="text" id="Input_ResourceName" name="Input.ResourceName"
        value={this.state.resourceSearch !== undefined ? this.state.resourceSearch : ''}
        onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, resourceSearch: val})); this.populateCalendarData(); this.populateResourcesData();}}/>
      </div>
      {this.state.companyId ? this.state.regions.map((r, i) =>
        <ReactRegionSelect
          maxRegions={100}
          regions={r/*this.state.regions[i]*/}
          regionStyle={regionStyle}
          regionRenderer={this.regionRenderer}
          handles={null}
          onChange={this.onRegionChange}>
          <img src={this.state.resources.filter(res => res.companyImages)[0].companyImages[r[0].data.mapId - 1]} class="schemeimg"/>
        </ReactRegionSelect>
      ):<></>}
      {this.state.resources.filter(res => !this.state.resourceId || this.state.resourceId === res.id).length > 0 ? <div><div style={this.state.resources.filter(res => res.bookingInterval <= 3).length==0?{marginLeft: "0px"}:{}} class="tableverybig"><table className="table table-striped" style={{width: "auto"}} aria-labelledby="tabelLabel">
        <thead>
          <tr>
            {this.state.resources.filter(res => res.bookingInterval <= 3).length==0?<></>:<th class="tablefix" style={{height: "200px"}}>Время</th>}
            {this.state.resources.filter(res => !this.state.resourceId || this.state.resourceId === res.id).map((res, i) =>
              <th style={i==0 && res.bookingInterval<=3?{borderLeft: "0", padding: "0"}:{padding: "0"}} onClick={() => this.selectResource(res.id)} className={this.state.resourceId === res.id?'react-calendar__tile--active':''}>
                <div class="resourcesq">
                  <div class="resourcesmallimagesq">
                  <Popup ref={this.selectorRef}
                    className="popup-info"
                    trigger={open => (
                      <span className="iimage"></span>
                    )}
                    onOpen={() => this.onResourceInfoOpen(res.id)}
                    position="bottom center"
                    repositionOnResize
                    closeOnDocumentClick>
                    {() => this.renderResourceInfo(res)}
                  </Popup>
                  <img class="noimagesm" width="70px" height="70px" alt="" src={res.images[0]}/>
                  </div>
                  <div>{res.name}{res.count>1?" ("+res.count+")":""}</div>
                </div>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {Array.from(Array((this.findMax(this.state.resources) - this.findMin(this.state.resources))/100).keys()).map(pos => this.RenderRow(pos + this.findMin(this.state.resources)/100))}
        </tbody>
      </table></div></div> : <h1>No resources available, please extend filter</h1>}
      </div>
    );
  }

  renderFilters() {
    if (!this.state.serviceId && !this.state.companyId) {
      return <></>;
    }
    return (
      <><p>Фильтры</p>
      <div className="tabledivbig" style={{overflow: "visible"}}>
        {this.state.filters.map(res =>
          <div>{res.name?<label>{res.name}</label>:<></>}<table class="table-filter"><tr>{res.items.map(p => 
            <td key={p.id} onClick={() => this.addFilter(p.id)} className={this.state.selectedFilters.includes(p.id)?'react-calendar__tile--active':''}>{p.name}</td>
          )}</tr></table></div>
        )}
        {this.state.serviceId?
        <div style={{height: "45px"}}>
          <label style={{margin: '0 10px 10px 0'}}>Цена</label>
          <div class="form-control-slider">
            <MultiRangeSlider
              min={this.state.minPrice !== undefined ? this.state.minPrice : 0}
              max={this.state.maxPrice !== undefined ? this.state.maxPrice : 10000}
              onChange={({ min, max }) => {console.log(`min = ${min}, max = ${max}`); this.setState(prevState => ({...prevState, minPriceVal: min, maxPriceVal: max})); this.populateResourcesData();}}
            />
          </div>
        </div>:<></>}
        <div style={{height: "45px"}}>
          <label style={{margin: '0 10px 10px 0'}}>Рейтинг</label>
          <div class="form-control-slider">
            <MultiRangeSlider
              min={0}
              max={5}
              onChange={({ min, max }) => {console.log(`min = ${min}, max = ${max}`); this.setState(prevState => ({...prevState, minRatingVal: min, maxRatingVal: max})); this.populateResourcesData();}}
            />
          </div>
        </div>
      </div></>
    );
  }

  selectCity(newValue) {
    const locationX = newValue.mapPositionX1+(newValue.mapPositionX2-newValue.mapPositionX1)/2;
    const locationY = newValue.mapPositionY1+(newValue.mapPositionY2-newValue.mapPositionY1)/2;
    this.setState(prevState => ({...prevState, city: newValue, zoom: 8, geoposition: [locationX, locationY], bounds: [[newValue.mapPositionX1, newValue.mapPositionY1],[newValue.mapPositionX2,newValue.mapPositionY2]]}));
  }

  selectSort(newValue) {
    this.setState(prevState => ({...prevState, sort: newValue}));
    this.populateCompaniesData();
  }

  debounce(func, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);  
      }, delay);
    };
  };

  async fetchOptions(inputValue, callback) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/geo?filter=${encodeURIComponent(inputValue)}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    const mapped = data.map(d=>({value: d.name, label: d.name, mapPositionX1: d.mapPositionX1, mapPositionY1: d.mapPositionY1, mapPositionX2: d.mapPositionX2, mapPositionY2: d.mapPositionY2}));
    this.setState(prevState => ({...prevState, cities: mapped}));
    callback(mapped);
  }

  render() {
    let services = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderServicesTable();

    let calendar = this.state.services.filter(s => s.id === this.state.serviceId).length === 0 && !this.state.companyId ? <></> : this.renderCalendar();

    return (
      <div>
        <h4 id="tabelLabel">Система бронирования</h4>
        {this.renderCategories()}
        <div style={{paddingBottom: "1rem"}}><div class="searchimg"><i class="fa-solid fa-magnifying-glass fa-xl"></i></div>
          <AsyncSelect
              className="formselect2"
              classNamePrefix="select"
              cacheOptions
              defaultOptions={this.state.cities}
              placeholder="Search cities..."
              loadOptions={this.debouncedLoadOptions}
              noOptionsMessage={() => "No Cities Found"}
              onChange={(newValue) => this.selectCity(newValue)}
              value={this.state.city}
            />
        <input class="form-control searchinput2" type="text" id="Input_ServiceName" name="Input.ServiceName"
          value={this.state.serviceSearch !== undefined ? this.state.serviceSearch : ''}
          onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, serviceSearch: val})); this.populateServicesData(); this.populateCompaniesData();}}
        /></div>
        <p>Услуги</p>
        <div class="maincont">
          {services}
          <div class="companysort"><span>Компании</span><span class='sortimg'></span>
            <div className={this.state.sort === 1?'sorticon react-calendar__tile--active':'sorticon'} onClick={() => this.selectSort(1)}><span className='sortpopimg'/></div>
            <div className={this.state.sort === 2?'sorticon react-calendar__tile--active':'sorticon'} onClick={() => this.selectSort(2)}><span className='sortpriceimg'/></div>
            <div className={this.state.sort === 3?'sorticon react-calendar__tile--active':'sorticon'} onClick={() => this.selectSort(3)}><span className='sortrateimg'/></div>
            <div className={this.state.sort === 4?'sorticon react-calendar__tile--active':'sorticon'} onClick={() => this.selectSort(4)}><span className='sortdistimg'/></div>
          </div>
          {this.renderCompaniesTable()}
          {this.renderFilters()}
          {calendar}
        </div>
      </div>
    );
  }

  async populateCurrentCity() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/geo/coord?x=${this.state.geoposition[0]}&y=${this.state.geoposition[1]}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const d = await response.json();
    if (!d) {
      return;
    }
    const mapped = ({value: d.name, label: d.name, mapPositionX1: d.mapPositionX1, mapPositionY1: d.mapPositionY1, mapPositionX2: d.mapPositionX2, mapPositionY2: d.mapPositionY2});
    this.setState(prevState => ({...prevState, cities: [mapped], city: mapped}));
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    var url = `{{mainApiUrl}}api/companies`;
    if (this.state.serviceId > 0)
      url = `{{mainApiUrl}}api/companies/service/${this.state.serviceId}`;
    else if (this.state.categoryIds.length > 0)
      url = `{{mainApiUrl}}api/companies/servicecategory/${this.state.categoryIds[this.state.categoryIds.length - 1]}`;
    url += `?sort=${this.state.sort}`;
    if (this.state.serviceSearch)
      url += `&search=${this.state.serviceSearch}`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data, companyId: data.filter(company => company.id === this.state.companyId).length > 0 ? this.state.companyId : 0}));
  }

  async populateCategoriesData() {
    const token = await authService.getAccessToken();
    var url = this.state.fixedCompanyId?`{{mainApiUrl}}api/services/companycategories/${this.state.fixedCompanyId}`: `{{mainApiUrl}}api/services/categories`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, categories: data}));
  }

  async populateCategoriesList(categoryId) {
    const token = await authService.getAccessToken();
    var url = this.state.fixedCompanyId?`{{mainApiUrl}}api/services/companycategories/${this.state.fixedCompanyId}/${categoryId}`:`{{mainApiUrl}}api/services/categories/${categoryId}`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    if (data.length > 0)
      this.setState(prevState => ({...prevState, categoryLists: [...this.state.categoryLists, data]}));
  }

  async populateServicesData() {
    const token = await authService.getAccessToken();
    if (this.state.categoryIds.length === 0 && !this.state.companyId && !this.state.serviceSearch) {
      this.setState(prevState => ({...prevState, services: [], loading: false}));
      return;
    }
    var url = this.state.companyId > 0 
      ? `{{mainApiUrl}}api/services/${this.state.companyId}`
      : `{{mainApiUrl}}api/services`;
    if (this.state.categoryIds.length > 0) {
      url += `?categoryId=${this.state.categoryIds[this.state.categoryIds.length - 1]}`;
      if (this.state.serviceSearch)
        url += `&search=${this.state.serviceSearch}`;
    } else if (this.state.serviceSearch)
      url += `?search=${this.state.serviceSearch}`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, services: data, loading: false}));
  }

  async populateOrdersData() {
    const token = await authService.getAccessToken();
    var date = new Date(this.state.selectedDate.getTime() - this.state.selectedDate.getTimezoneOffset() * 60000);
    var url = this.state.companyId > 0
      ? `{{mainApiUrl}}api/services/${this.state.serviceId}/orders/${this.state.companyId}`
      : `{{mainApiUrl}}api/services/${this.state.serviceId}/orders`;
    url += `?date=${date.toLocaleDateString('en-US')}`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, orders: data}));
  }

  async populateResourcesData() {
    const token = await authService.getAccessToken();
    var date = new Date(this.state.selectedDate.getTime() - this.state.selectedDate.getTimezoneOffset() * 60000);
    const filter = this.state.selectedFilters.map(f => 'filter=' + f.toString()).join('&');
    var url = this.state.companyId > 0 
      ? `{{mainApiUrl}}api/services/${this.state.serviceId}/resources/${this.state.companyId}`
      : `{{mainApiUrl}}api/services/${this.state.serviceId}/resources`;
    url += `?${filter}&date=${date.toLocaleDateString('en-US')}`;
    if (this.state.minPriceVal)
      url += `&minPrice=${this.state.minPriceVal}`;
    if (this.state.maxPriceVal)
      url += `&maxPrice=${this.state.maxPriceVal}`;
    if (this.state.resourceSearch)
      url += `&search=${this.state.resourceSearch}`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, regions: [], resources: data, resourceId: null}));
    if (this.state.companyId && this.state.resources.filter(r => r.companyImages.length > 0).length > 0) {
      var regions = this.state.resources.map(r => r.mapId).filter((value, index, array) => value !== null && array.indexOf(value) === index).map((mapId, ind) => {
        return this.state.resources.filter(r => r.mapId === mapId && r.locationX !== null).map((r, i) => { return {x: r.locationX, y: r.locationY, width: r.locationWidth, height: r.locationHeight, data: {index: i, resource: r, mapId: mapId, mapIndex: ind}, isChanging: false, new: true}});
      });
      this.setState(prevState => ({...prevState, regions: regions}));
    }
  }

  async populateCalendarData() {
    const token = await authService.getAccessToken();
    var date = new Date(this.state.selectedMonth.getTime() - this.state.selectedMonth.getTimezoneOffset() * 60000);
    const filter = this.state.selectedFilters.map(f => 'filter=' + f.toString()).join('&');
    var url = this.state.companyId > 0 
      ? `{{mainApiUrl}}api/services/${this.state.serviceId}/resourcescalendar/${this.state.companyId}`
      : `{{mainApiUrl}}api/services/${this.state.serviceId}/resourcescalendar`;
    url += `?${filter}&month=${date.toLocaleDateString('en-US')}`;
    if (this.state.minPriceVal)
      url += `&minPrice=${this.state.minPriceVal}`;
    if (this.state.maxPriceVal)
      url += `&maxPrice=${this.state.maxPriceVal}`;
    if (this.state.resourceSearch)
      url += `&search=${this.state.resourceSearch}`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, calendar: data}));
  }

  async populateFiltersData() {
    const token = await authService.getAccessToken();
    var url = this.state.companyId > 0 
      ? `{{mainApiUrl}}api/companies/resourceparamgroups/${this.state.companyId}`
      : `{{mainApiUrl}}api/companies/resourceparamgroups/0/${this.state.serviceId}`;
    url += `?hideempty=true`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    const selfil = this.state.selectedFilters.filter(sf => {
      let found = false;
      data.forEach(f => {
        found = found || f.items.filter(i => i.id === sf).length > 0;
      });
      return found;
    });
    this.setState(prevState => ({...prevState, filters: data, selectedFilters: selfil}));
  }

  async populateUserData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/users/phone?phone=${encodeURIComponent(this.state.phone)}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();

    const response2 = await fetch(`{{userApiUrl}}api/users/phone?phone=${encodeURIComponent(this.state.phone)}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data2 = await response2.json();
    this.setState(prevState => ({...prevState, globalUsersMain: data, globalUsersIdentity: data2, userName: data.length == 1 ? data[0].firstName : this.state.userName}));
  }
}
